import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { MoreVertical, Pencil, History, UserX } from 'lucide-react';

export interface UserCompensation {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  [key: string]: any;
}

interface CompensationRowActionsProps {
  user: UserCompensation;
  onEdit: (user: UserCompensation) => void;
  onViewHistory?: (user: UserCompensation) => void;
  onDeactivate?: (userId: string) => void;
}

export const CompensationRowActions: React.FC<CompensationRowActionsProps> = ({
  user,
  onEdit,
  onViewHistory,
  onDeactivate
}) => {
  const handleEdit = () => {
    onEdit(user);
  };

  const handleViewHistory = () => {
    if (onViewHistory) {
      onViewHistory(user);
    }
  };

  const handleDeactivate = () => {
    if (onDeactivate) {
      const confirmed = window.confirm(
        `Are you sure you want to deactivate ${user.first_name} ${user.last_name}? They will no longer be able to access the system.`
      );
      if (confirmed) {
        onDeactivate(user.id);
      }
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
        >
          <span className="sr-only">Open menu</span>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleEdit}>
          <Pencil className="mr-2 h-4 w-4" />
          Edit Compensation
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleViewHistory}>
          <History className="mr-2 h-4 w-4" />
          View History
        </DropdownMenuItem>
        {onDeactivate && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={handleDeactivate}
              className="text-red-600 focus:text-red-600 focus:bg-red-50"
            >
              <UserX className="mr-2 h-4 w-4" />
              Deactivate User
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
